<h1>Shopping Cart ({{cartService.CartItemCount}})</h1>
<div id="sales-header" class="p-3 mb-2">
  <app-dynamic-content blocktitle="Shopping cart sales header - {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}" [inline]="true"></app-dynamic-content>
</div>
<ng-container *ngIf="ucdService.IsLoggedIn; else noUser">
  <ng-container *ngIf="cartService.CartLoaded; else loadingCart">
    <ng-container *ngIf="(CartDetails$ | async) as cart; else emptyCart">
      <ng-container *ngIf="ItemArray.length > 0; else emptyCart">
        <main id="cart" class="row">
          <div id="cart-items" class="col">
            <ng-container *ngIf="ItemArray">
              <header class="d-flex justify-content-between p-2 border-bottom text-uppercase">
                <span>Product</span>
                <span>Price</span>
              </header>
              <section *ngFor="let cartItem of ItemArray" class="d-flex justify-content-between p-2 border-bottom">
                  <span><a
                      [routerLink]="['..', cartItem.Type == 'Course' ? 'course' : 'package', cartItem.Item.alias]">{{cartItem.Item.title}}</a><br />
                    <a *ngIf="!cartService.PendingUpdate" class="cart-remove"
                      (click)="RemoveItem(cartItem.type, cartItem.itemId)">Remove</a>
                    <fa-icon *ngIf="cartService.PendingUpdate" icon="spinner" [spin]="true"></fa-icon>
                  </span>

                  <span>${{cartItem.Price}}</span>
              </section>
              <footer class="d-flex justify-content-between p-2 border-bottom text-uppercase">
                <a (click)="cartService.ClearCart().subscribe();">Empty Cart</a>
                <a routerLink="../courses">Continue Shopping</a>
              </footer>
            </ng-container>
          </div>

          <div id="cart-other" class="col mt-2 mb-3">
            <div id="cart-summary" class="border border-dark container">
              <header class="border-bottom border-dark mx-1 py-2">
                <div class="row">
                  <span class="col text-right">Subtotal</span>
                  <span class="col-4 text-right">
                    <span *ngIf="!cartService.PendingUpdate">${{cart.Subtotal}}</span>
                    <fa-icon *ngIf="cartService.PendingUpdate" icon="spinner" [spin]="true"></fa-icon>
                  </span>
                </div>
              </header>
              <section class="mx-1 py-2">
                <div class="row font-weight-bold" *ngFor="let discount of cart.Discounts">
                  <span class="col text-right">{{discount.prc_display_name}}</span>
                  <span class="col-4 text-right">
                    <span *ngIf="!cartService.PendingUpdate">-${{discount.ivd_total}}</span>
                    <fa-icon *ngIf="cartService.PendingUpdate" icon="spinner" [spin]="true"></fa-icon>
                  </span>
                </div>
                <div class="row">
                  <span class="col">
                    <app-cart-discount-upsell *ngIf="!cartService.PendingUpdate"></app-cart-discount-upsell>
                  </span>
                </div>
              </section>
              <footer class="border-top border-dark mx-1 py-2 font-weight-bold">
                <div class="row">
                  <span class="col text-right">Total</span>
                  <span class="col-4 text-right">
                    <span *ngIf="!cartService.PendingUpdate"><small>USD</small> ${{cart.Total}}</span>
                    <fa-icon *ngIf="cartService.PendingUpdate" icon="spinner" [spin]="true"></fa-icon>
                  </span>
                </div>
                <div class="row justify-content-end px-2">
                  <button *ngIf="cart.Total > 0" class="text-uppercase mt-2" (click)="ShowCheckout()">Checkout</button>
                </div>
              </footer>
            </div>

            <div id="cart-marketing" class="mt-4 shadow-sm">
              <header class="text-uppercase py-1 mb-1 text-center">Best Value</header>
              <section class="m-2 row">
                <p class="col">ABMP membership gives you these and 200+ other courses</p>
                <span class="col-4">$199</span>
              </section>
              <footer class="text-right pr-3 pb-3">
                <button class="text-uppercase" (click)="OpenJoinWindow()">Join now</button>
              </footer>
            </div>

            <div id="cart-promo" class="mt-4 border border-dark container text-uppercase">
              <header class="py-2">Promo Code</header>
              <section class="pb-2">
                <input type="text" #promocode (keyup)="UpdatePromoCode()" />
                <span *ngIf="promoCode==''" class="ml-4 font-weight-bold">Apply</span>
                <a *ngIf="promoCode!=''" class="ml-4" [routerLink]="null" (click)="ApplyPromoCode()">Apply</a>
              </section>
            </div>
          </div>
        </main>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #noUser>
  <p>Please <a [routerLink]="null" (click)="ShowLogin()">login</a> to access your shopping cart.</p>
</ng-template>
<ng-template #loadingCart>
  <p><app-load-indicator description="load your cart"></app-load-indicator></p>
</ng-template>
<ng-template #emptyCart>
  <p *ngIf="!cartService.PendingUpdate">You have no items in your cart.</p>
  <p *ngIf="cartService.PendingUpdate"><app-load-indicator description="update your cart."></app-load-indicator></p>
</ng-template>
